import { WPElement, createContext, useContext } from "@wordpress/element";
import { Listbox } from '@headlessui/react'
import { buildButton } from "./button";
import cx from "classnames";

const SelectButtonContext = createContext<string | undefined>( "" );

export function SelectButton( props: {
	variant: any,
	label: Function,
	leftIcon?: any,
	rightIcon?: any,
	children: WPElement | WPElement[],
	value?: string,
	size?: string,
	optionsClassName?: string,
	onChange?: ( ( value: string ) => void )
} ) {
	const btn = buildButton( {
		variant: props.variant,
		leftIcon: props.leftIcon,
		rightIcon: props.rightIcon,
		size: props.size
	} );

	const label = ( o: any ) => {
		if ( typeof ( props.label ) == "function" ) {
			return props.label
		} else {
			return props.label;
		}
	}

	return (
		<SelectButtonContext.Provider value={ props.value }>
			<Listbox defaultValue={ props.value } onChange={ props.onChange }>
				<div className="inline w-full md:w-auto whitespace-nowrap">
					<Listbox.Button className={ btn.className }>
						{ ( o: any ) => (
							btn.render( label( o ) )
						) }
					</Listbox.Button>
					<Listbox.Options className={ cx( 'absolute z-10 mt-1 overflow-hidden rounded-md shadow-lg ring-1 ring-ui-300 focus:outline-none', props.optionsClassName ) }>
						<div className="bg-white text-ui-700">
							<>
								{ props.children }
							</>
						</div>
					</Listbox.Options>
				</div>
			</Listbox>
		</SelectButtonContext.Provider>
	)
}

SelectButton.Item = function ( props: { value: string, children: WPElement | WPElement[] } ) {
	const value = useContext( SelectButtonContext );

	return (
		<Listbox.Option
			className={
				( { active } ) =>
					cx(
						"relative whitespace-nowrap text-sm cursor-default select-none py-2 pl-4 pr-4",
						value == props.value ? "font-semibold" : "",
						active ? "bg-ui-100" : ""
					)
			}
			value={ props.value }
		>
			<>
				{ props.children }
			</>
		</Listbox.Option>
	)
}
